/**
 * @file 模型库结构图弹窗
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useCallback, useEffect, useState} from 'react';

interface IImgSize {
    height: number;
    width: number;
}

interface IProps {
    imgSrc?: string;
}

// 获取一个图片的原始长宽
const getImgSize = (src: string) => new Promise<IImgSize>(resolve => {
    const image = new Image();
    image.onload = () => {
        resolve({
            height: image.height,
            width: image.width
        });
    };
    image.src = src;
});

export const useModelBaseStructureModalHooks = (props: IProps) => {
    const [imgScale, setImgScale] = useState<number>(1);
    const [visible, setVisible] = useState<boolean>(false);
    const [imgSize, setImgSize] = useState<IImgSize>({
        height: 0,
        width: 0
    });

    const {imgSrc} = props;

    const onModalHide = useCallback(() => {
        setVisible(false);
    }, [setVisible]);

    const onModalShow = useCallback(() => {
        setVisible(true);
    }, [setVisible]);

    const onZoomInClick = useCallback(() => {
        setImgScale(oldScale => oldScale * 1.25);
    }, [setImgScale]);

    const onZoomOutClick = useCallback(() => {
        setImgScale(oldScale => oldScale * 0.75);
    }, [setImgScale]);

    useEffect(() => {
        if (imgSrc) {
            getImgSize(imgSrc).then(({width, height}) => {
                // 如果图片比屏幕宽，则寻找一个合适的缩放比例，让图片的宽度比窗口宽度略小。
                // 如果图片太窄，以至于容易和背景融为一体，则适当放大
                // 同时缩放比例还是固定的数列
                let scale = 1;
                const windowWidth = window.innerWidth;
                if (width > windowWidth) {
                    for (let i = 1; i < 1000; i++) {
                        const radio = Math.pow(0.75, i);
                        if (width * radio < windowWidth) {
                            scale = radio;
                            break;
                        }
                    }
                }
                else if (width < 200) {
                    for (let i = 1; i < 1000; i++) {
                        const radio = Math.pow(1.25, i);
                        scale = radio;
                        if (width * radio >= windowWidth) {
                            break;
                        }
                    }
                }
                setImgSize({
                    height,
                    width
                });
                setImgScale(scale);
            });
        }
    }, [imgSrc]);

    return {
        visible,
        imgScale,
        imgSize,

        onModalHide,
        onModalShow,
        onZoomInClick,
        onZoomOutClick
    };
};
